import * as React from 'react'

import { observer } from 'mobx-react'

import { IProjectAddressInput } from '~/client/graph/types.generated'
import { IMapBoxFeature } from '~/client/src/shared/interfaces/IMapBoxFeature'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import ProjectMapboxAddressField from './ProjectMapboxAddressField'

interface IProps {
  projectAddress: IProjectAddressInput
  projectAddressSuggestions: IMapBoxFeature[]
  isNewProjectSelected: boolean
  isAdressButtonDisabled: boolean
  mapBoxOnAddressValueChanged: (item: IMapBoxFeature) => void
  mapBoxOnQueryChange: (query: string) => Promise<void>
  onSaveAddress: () => void
  renderDoneButton(
    clickHandler: () => void,
    isHidden?: boolean,
    isDisabled?: boolean,
  ): JSX.Element
}

const ProjectLocationBlock: React.FC<IProps> = observer(
  ({
    projectAddress,
    projectAddressSuggestions,
    isNewProjectSelected,
    isAdressButtonDisabled,
    mapBoxOnAddressValueChanged,
    mapBoxOnQueryChange,
    onSaveAddress,
    renderDoneButton,
  }: IProps) => {
    const { address, city, state, zipcode, country } = projectAddress
    const addressString = `${address} ${city} ${state} ${zipcode} ${country}`

    return (
      <div className="tw:flex tw:items-start tw:gap-3 tw:px-[30px] tw:py-2">
        <div className="tw:w-[350px]">
          <ProjectMapboxAddressField
            id="project-details-project-location"
            label={Localization.translator.projectLocation}
            fullAddressLabel={addressString}
            items={projectAddressSuggestions}
            onItemSelect={mapBoxOnAddressValueChanged}
            onQueryChange={mapBoxOnQueryChange}
          />
        </div>
        {!isNewProjectSelected &&
          renderDoneButton(onSaveAddress, isAdressButtonDisabled)}
      </div>
    )
  },
)

export default ProjectLocationBlock
